export const appSettings = {
    appTitle: 'Simple Forms UI',
    appName: 'simple-forms-ui',
    rootId: 'simple-forms-ui-root',
    apiName: 'simple-forms-api'
}
